import Plausible from 'plausible-tracker';
import { Environment } from '../Environment';

let plausible: ReturnType<typeof Plausible> | null = null;

async function getPlausible() {
  if (typeof window === 'undefined') return null;

  if (!plausible) {
    var environment = await Environment.getInstance()
    plausible = Plausible({ domain:environment.plausibleSite });
  }

  return plausible;
}

export async function trackPageview(url?: string) {
  const p = await getPlausible();

  if (!p) return;

  var environment = await Environment.getInstance()
  p.trackPageview({
    url,
    domain: environment.plausibleSite, // 👈 force it
  } as any);
}

export async function trackEvent(name: string, props?: Record<string, any>) {
  const p = await getPlausible();
  if (!p) return;
  p.trackEvent(name, { props });
}